function loadMoreProducts() {
  let currentPage = 1;
  const loadMoreButton = document.getElementById("load-more");
  const button = loadMoreButton?.querySelector("button");
  const spinner = loadMoreButton?.querySelector(".loading__spinner");
  const buttonText = loadMoreButton?.querySelector("span");
  const productGrid = document.querySelector("#product-grid");
  const paginationInfo = document.querySelector(".product-pagination-info");

  if (
    !loadMoreButton ||
    !button ||
    !spinner ||
    !buttonText ||
    !productGrid ||
    !paginationInfo
  )
    return;

  button.addEventListener("click", function () {
    currentPage++;

    buttonText.style.display = "none";
    spinner.classList.remove("hidden");

    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set("page", currentPage);
    const nextUrl = `${window.location.pathname}?${currentParams.toString()}`;

    fetch(nextUrl)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newProducts = doc.querySelectorAll("#product-grid .product-item");

        const totalProducts = parseInt(
          doc
            .querySelector(".product-pagination-info")
            .getAttribute("data-total"),
          10
        );

        const currentlyDisplayed = document.querySelectorAll(
          "#product-grid .product-item"
        ).length;

        newProducts.forEach((item) => {
          productGrid.appendChild(item);
          addProdEvents(item);
        });

        const nextDisplayed = currentlyDisplayed + newProducts.length;
        paginationInfo.innerHTML = `Viewing 1 - ${Math.min(
          nextDisplayed,
          totalProducts
        )} out of ${totalProducts} products`;

        if (!doc.querySelector("#load-more")) {
          loadMoreButton.remove();
        }
      })
      .catch((error) => console.log("Error loading more products:", error))
      .finally(() => {
        buttonText.style.display = "inline";
        spinner.classList.add("hidden");
      });
  });
}

const addProdEvents = (prod) => {
  const colorOptionsEle = prod.querySelector(`.card__color-options`);
  const prodId = colorOptionsEle.getAttribute("product-id");

  const quickAddForm = prod.querySelector(".card__action product-form form");

  initColorSelector(prodId, undefined, quickAddForm);
};

document.addEventListener("DOMContentLoaded", loadMoreProducts);
